import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CreateReferralUrlRequest {
  agentCode: number;
  referralUrl: string;
}

export interface ReferralUrl {
  id: number;
  agentCode: number;
  referralUrl: string;
  createdAt: string;
  updatedAt: string;
  expiresAt?: string;
}

export interface ReferralUrlWithCount {
  id: number;
  agentName: string;
  agentCode: number;
  referralUrl: string;
  createdAt: string;
  updatedAt: string;
  count?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ReferralUrlService {
  private apiUrl = `${environment.apiUrl}/referral-url`;

  constructor(private http: HttpClient) {}

  createReferralUrl(payload: CreateReferralUrlRequest): Observable<ReferralUrl> {
    return this.http.post<ReferralUrl>(this.apiUrl, payload);
  }

  getByAgentCode(agentCode: number, activeOnly = false): Observable<ReferralUrl[]> {
    return this.http.get<ReferralUrl[]>(`${this.apiUrl}?agentCode=${agentCode}&activeOnly=${activeOnly}`);
  }

  getAgentCodeByReferralUrl(referralUrl: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/agent`, {
      params: {
        referralUrl: referralUrl,
        activeOnly: true
      }
    });
  }

  getReferralUrlClicks(agentCode: number): Observable<number> {
    return this.http.get<number>(`${environment.apiUrl}/analytics/agents/${agentCode}/click-count`);
  }

  getAllReferrals(): Observable<ReferralUrlWithCount[]> {
    return this.http.get<ReferralUrlWithCount[]>(`${this.apiUrl}/all`);
  }
}